<div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
        <div class="col-lg-12">
            <div class="row m-b-lg m-t-lg" >
                <div class="col-md-6">
                    <div class="profile-image" >
                        <img class= "rounded-circle circle-border m-b-md imagenPersona"
                             alt="image" title="Cambiar Imagen" style="cursor: pointer;" 
                             [src]="profileImage" (click)="imageInput.click()"
                             [ngClass]="{'img-disabled' : !showDetails}">

                        <input  type="file" 
                                accept="image/png, image/jpeg" 
                                style="display: none;" 
                                (change)="onFileSelected($event)"
                                #imageInput/>
                    </div>
                    <div class="profile-info">
                        <div class="">
                            <div>
                                <h2 class="combo">
                                    <p-dropdown [options]="personal" [(ngModel)]="selectedPersonal" optionLabel="code" [filter]="true" 
                                        filterBy="code,displayName" [showClear]="true" placeholder="Seleccione Empleado"
                                        (onChange)="onChangePersonal($event)">
                                        <ng-template pTemplate="selectedItem">
                                            <div class=" personal-item personal-item-value"  *ngIf="selectedPersonal">
                                                <div>{{selectedPersonal.code}} - {{selectedPersonal.displayName}}</div>
                                            </div>
                                        </ng-template>
                                        <ng-template let-personal pTemplate="item">
                                            <div class="personal-item">
                                                <div>{{personal.code}} - {{personal.displayName}}</div>
                                            </div>
                                        </ng-template>
                                    </p-dropdown>
                                </h2>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5" *ngIf="showDetails">
                    <table class="table small m-b-xs detalles">
                        <tbody>
                        <tr>
                            <td>
                                Edad: <strong>{{edad}}</strong> años
                            </td>
                            <td>
                                Fecha de nacimiento: <strong>{{personalRelacion.fechaNacimiento | date: 'dd/MM/yyyy'}}</strong> 
                            </td>

                        </tr>
                        <tr>
                            <td>
                                Teléfono: <strong>{{personalRelacion.celular}}</strong>
                            </td>
                            <td>
                                Interno: <strong>{{personalRelacion.interno}}</strong>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-1" *ngIf="showDetails">
                    <br>
                    <div class="buttons" *ngIf="permisoBorrado">
                        <button class="btn btn-danger" type="submit" (click)="borrarPersonal()" [disabled]="!permisoBorrado">Borrar</button>
                    </div>                                
                </div>
            </div>
        </div>
        <div class="col-lg-12" *ngIf="Invalido">
            <mat-error *ngIf="Invalido" class="Invalido">{{MensajeError}}</mat-error>
        </div>        
        <div class="col-lg-12">
            <app-personal-detail *ngIf="showDetails"
                [personalCode]="selectedEmp" [personalPar]='personalRelacion'
            ></app-personal-detail>
        </div>
    </div>
</div>